// src/container/ContainerContext.ts
import React from "react";
var ContainerContext = React.createContext(null);

// src/container/ContainerProvider.tsx
import React3 from "react";

// src/container/useContainer.ts
import React2 from "react";
function useContainer(strict = true) {
  const container = React2.useContext(ContainerContext);
  if (strict && container === null) {
    throw new Error("Could not get a container from a context. Did you forget to pass the container through 'ContainerProvider'?");
  }
  return container;
}

// src/container/ContainerProvider.tsx
var ContainerProvider = ({children, container, isolated = false}) => {
  const parentContainer = useContainer(false);
  const extend = !isolated ? parentContainer : null;
  const clonedContainer = React3.useMemo(() => {
    const cloned = container.clone();
    if (extend)
      cloned.extend(extend);
    return cloned;
  }, [container, extend]);
  return /* @__PURE__ */ React3.createElement(ContainerContext.Provider, {
    value: clonedContainer
  }, children);
};

// src/injection/useInjection.ts
import React8 from "react";

// src/conditions/ConditionsContext.ts
import React4 from "react";
var ConditionsContext = React4.createContext([]);

// src/conditions/ConditionsProvider.tsx
import React6 from "react";

// src/conditions/useConditions.ts
import React5 from "react";
var useConditions = () => React5.useContext(ConditionsContext);

// src/conditions/ConditionsProvider.tsx
var ConditionsProvider = ({children, conditions, isolated = false}) => {
  const currentConditions = useConditions();
  const resolvedConditions = React6.useMemo(() => currentConditions.length > 0 && !isolated ? [...new Set([...currentConditions, ...conditions])] : conditions, [currentConditions, conditions, isolated]);
  return /* @__PURE__ */ React6.createElement(ConditionsContext.Provider, {
    value: resolvedConditions
  }, children);
};

// src/conditions/tagged.tsx
import React7 from "react";
var tagged = (...tags) => (Component, options = {}) => {
  const Wrapper = (props) => /* @__PURE__ */ React7.createElement(ConditionsProvider, {
    conditions: tags,
    isolated: options.isolated
  }, /* @__PURE__ */ React7.createElement(Component, {
    ...props
  }));
  Wrapper.displayName = Component.displayName ? `Tagged(${Component.displayName})` : "Tagged";
  return Wrapper;
};

// src/injection/useInjection.ts
var useInjection = (token) => {
  const container = useContainer();
  const conditions = useConditions();
  return React8.useMemo(() => container.get(token, conditions), [
    token,
    conditions,
    container
  ]);
};

// src/injection/createInjectionHooks.ts
var createInjectionHooks = (...tokens) => tokens.map((token) => () => useInjection(token));
export {
  ContainerProvider,
  createInjectionHooks,
  tagged,
  useInjection
};
//# sourceMappingURL=brandi-react.mjs.map
